import React, { useEffect, useState } from "react";

interface CsrfTokenWatcherProps {
  onTokenAvailable: (token: string) => void;
}

/**
 * CsrfTokenWatcher Component
 * @param {function} onTokenAvailable - Callback to provide the CSRF token when it's available.
 * @returns null
 */
const CsrfTokenWatcher: React.FC<CsrfTokenWatcherProps> = ({ onTokenAvailable }) => {
  const [csrfToken, setCsrfToken] = useState();

  useEffect(() => {
    const fetchCsrfToken = () => {
      const metaTag = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
      if (metaTag && metaTag.content !== csrfToken) {
        const token = metaTag.content;
        setCsrfToken(token);
        onTokenAvailable(token);
      }
    };

    if (document.readyState === "complete") {
      fetchCsrfToken();
    } else {
      window.addEventListener("load", fetchCsrfToken);
    }

    // Set up MutationObserver as a fallback for late additions
    const observer = new MutationObserver(() => {
      fetchCsrfToken();
    });
    observer.observe(document.head, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("load", fetchCsrfToken);
      observer.disconnect();
    };
  }, [csrfToken, onTokenAvailable]);

  return null;
};

export default CsrfTokenWatcher;
